export default function Capabilities() {
  const capabilities = [
    {
      icon: 'ri-recycle-fill',
      title: 'Waste to Value Innovation',
      description: 'Innovative and efficient processes transform raw materials that would otherwise be waste into valuable finished chrome products',
      stats: 'Value Creation'
    },
    {
      icon: 'ri-building-fill',
      title: 'Rustenburg Processing Plant',
      description: 'State-of-the-art processing facility in Rustenburg beneficiates ROM into high-grade chrome concentrate',
      stats: '1000MT Weekly'
    },
    {
      icon: 'ri-map-pin-fill',
      title: 'Strategic Location',
      description: 'Multiple raw material sources from mines and dumps within 70-120km radius in Northwest Province',
      stats: 'Northwest Province'
    },
    {
      icon: 'ri-team-fill',
      title: 'Experienced Management',
      description: 'Combined 40+ years of expertise across legal, mining, property, financial, marketing, sales, and engineering sectors',
      stats: '40+ Years'
    },
    {
      icon: 'ri-links-fill',
      title: 'Strategic Partnerships',
      description: 'Strong alliances with local and international industry players, plus partnerships with local transporters and communities',
      stats: 'Multi-faceted'
    },
    {
      icon: 'ri-line-chart-fill',
      title: 'Market Understanding',
      description: 'Deep knowledge of commodity markets with constant trend monitoring and competitive advantage in direct-from-source supply',
      stats: '8+ Years'
    }
  ];

  return (
    <section className="py-24 bg-[#F5F7FA]">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold mb-6 font-['Montserrat']">
            <span className="text-black">TMI </span>
            <span className="text-[#8B1538]">STRENGTHS</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto font-['Lato']">
            What makes Tlotlo Mfolwe Trading a trusted partner in the chrome industry
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {capabilities.map((capability, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-[#8B1538] to-[#6B6B6B] rounded-xl flex items-center justify-center mb-6">
                <i className={`${capability.icon} text-white text-3xl`}></i>
              </div>
              
              <div className="mb-4">
                <div className="text-3xl font-bold text-[#8B1538] mb-2">
                  {capability.stats}
                </div>
                <h3 className="text-2xl font-bold text-[#2C3E50] mb-3">
                  {capability.title}
                </h3>
              </div>
              
              <p className="text-gray-600 leading-relaxed">
                {capability.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-[#8B1538] to-[#6B6B6B] rounded-3xl p-12 text-white">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-4xl font-bold mb-6 font-['Montserrat']">
                Competitive Advantage
              </h3>
              <p className="text-lg text-white/90 mb-6 leading-relaxed">
                While the chrome market is controlled by big mining houses, TMI has established itself as the go-to supplier for clients who prefer to buy products from source at more competitive prices. Big mining houses don't allow clients to buy locally as it reduces their profit margins - this becomes TMI's winning advantage.
              </p>
              <ul className="space-y-3">
                <li className="flex items-center gap-3">
                  <i className="ri-check-double-line text-2xl text-white"></i>
                  <span>Direct from source pricing advantage</span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-check-double-line text-2xl text-white"></i>
                  <span>Flexible supply arrangements</span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-check-double-line text-2xl text-white"></i>
                  <span>Strong client relationships</span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-check-double-line text-2xl text-white"></i>
                  <span>Reliable supply chain network</span>
                </li>
              </ul>
            </div>
            
            <div className="relative h-[400px] rounded-2xl overflow-hidden">
              <img 
                src="https://public.readdy.ai/ai/img_res/8079aaec02244db953c97abec0b3c00d.jpg"
                alt="Chrome Quality Control"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        <div className="mt-16 grid md:grid-cols-2 gap-8">
          <div className="bg-white rounded-2xl p-10 shadow-lg">
            <div className="w-16 h-16 bg-[#8B1538] rounded-xl flex items-center justify-center mb-6">
              <i className="ri-lightbulb-fill text-white text-3xl"></i>
            </div>
            <h3 className="text-3xl font-bold text-[#2C3E50] mb-4">
              Market Opportunities
            </h3>
            <p className="text-gray-600 leading-relaxed mb-4">
              Chrome is one of the most sought-after minerals globally. South Africa has huge deposits, making it an ideal sourcing location for global markets. The demand for chrome consistently exceeds supply, creating strong market opportunities.
            </p>
            <ul className="space-y-2 text-gray-600">
              <li className="flex items-start gap-2">
                <i className="ri-arrow-right-s-line text-[#8B1538] text-xl mt-0.5"></i>
                <span>Limited number of chrome processing plants in the market</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-arrow-right-s-line text-[#8B1538] text-xl mt-0.5"></i>
                <span>Existing plants lack capacity to meet client demand</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-arrow-right-s-line text-[#8B1538] text-xl mt-0.5"></i>
                <span>Big mining houses reducing production levels increases prices</span>
              </li>
            </ul>
          </div>

          <div className="bg-white rounded-2xl p-10 shadow-lg">
            <div className="w-16 h-16 bg-[#6B6B6B] rounded-xl flex items-center justify-center mb-6">
              <i className="ri-shield-check-fill text-white text-3xl"></i>
            </div>
            <h3 className="text-3xl font-bold text-[#2C3E50] mb-4">
              Future Security
            </h3>
            <p className="text-gray-600 leading-relaxed mb-4">
              TMI is actively pursuing mine acquisition to ensure long-term supply consistency and asset security. This strategic vision includes exclusive offtake agreements and on-site preparation capabilities.
            </p>
            <ul className="space-y-2 text-gray-600">
              <li className="flex items-start gap-2">
                <i className="ri-arrow-right-s-line text-[#6B6B6B] text-xl mt-0.5"></i>
                <span>Exclusive dump site offtake with local communities</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-arrow-right-s-line text-[#6B6B6B] text-xl mt-0.5"></i>
                <span>Plans for yellow machines on dump sites</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-arrow-right-s-line text-[#6B6B6B] text-xl mt-0.5"></i>
                <span>Consistent feed supply to processing plant</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
